import React from 'react';

import classnames from 'classnames';

import { Icon } from '../../../Icon';
import { Select } from '../../../Select';
import { useSelectRootContext } from '../../../Select/primitives/root/SelectRootContext';
import { useSelectedOption } from '../../../Select/primitives/root/useSelectedOption';
import { FlagImg } from '../FlagImg';

import styles from './FlagSelect.module.scss';

export const FlagSelectTrigger = () => {
    const { open, readOnly, disabled } = useSelectRootContext();
    const value = useSelectedOption();
    return (
        <Select.Trigger
            className={classnames(styles.trigger, {
                [styles.open]: open,
                [styles.readOnly]: readOnly,
                [styles.disabled]: disabled
            })}
        >
            {value?.option?.value ? (
                <FlagImg iso2={value.option.value} className={styles.flagImage} />
            ) : null}
            {!readOnly && (
                <Select.Arrow>
                    <Icon
                        name="s-icon-chevron-down-compact"
                        size="medium"
                        color="secondary"
                        className={styles.icon}
                    />
                </Select.Arrow>
            )}
        </Select.Trigger>
    );
};
